module.exports = __webpack_public_path__ + "img/45_13.85d15498.png";